import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { DimensionCostAllocationCardAllocationTypeSelect } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/cost-allocation-card/components/DimensionCostAllocationCardAllocationTypeSelect";
import { DimensionEnhancedSharedCost } from "@/store/dimensions/utils/types/common";
import { DimensionCostAllocationCardSharedAmountsTable } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/cost-allocation-card/components/shared-amounts-table/DimensionCostAllocationCardSharedAmountsTable";

interface DimensionCostAllocationCardAllocationTypeProps {
  sharedCost: DimensionEnhancedSharedCost;
}

export const DimensionCostAllocationCardAllocationType: FC<
  DimensionCostAllocationCardAllocationTypeProps
> = ({ sharedCost }) => {
  return (
    <Stack spacing={1.5}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2">2. Choose Allocation Type</Typography>

        <DimensionCostAllocationCardAllocationTypeSelect
          sharedCostId={sharedCost.id}
          distributionType={sharedCost.distribution_type}
        />
      </Stack>

      <DimensionCostAllocationCardSharedAmountsTable
        sharedCostId={sharedCost.id}
        distributionType={sharedCost.distribution_type}
        shareAmounts={sharedCost.share_amounts ?? []}
      />
    </Stack>
  );
};
